import type { BufferGeometry } from "three";
import type { MeshBVH } from "three-mesh-bvh";
// @ts-expect-error
import { GenerateMeshBVHWorker } from "three-mesh-bvh/src/workers/GenerateMeshBVHWorker";

const bvhWorker = new GenerateMeshBVHWorker();
const bvhQueue: Array<{
  geometry: BufferGeometry;
  resolve: (bvh: MeshBVH) => void;
  reject: (error: unknown) => void;
}> = [];
let processing = false;

async function processBvhQueue() {
  if (processing || bvhQueue.length === 0) return;
  processing = true;

  const item = bvhQueue.shift();
  if (item == null) {
    throw new Error("Unexpected null value even though bvhQueue.length > 0");
  }
  const { geometry, resolve, reject } = item;
  try {
    const bvh = await bvhWorker.generate(geometry);
    resolve(bvh);
  } catch (error) {
    console.error("BVH generation failed", error);
    reject(error);
  } finally {
    processing = false;
    processBvhQueue(); // Process the next item in the queue
  }
}

export async function computeBvhAsync(geometry: BufferGeometry): Promise<MeshBVH> {
  return new Promise((resolve, reject) => {
    bvhQueue.push({ geometry, resolve, reject });
    processBvhQueue();
  });
}
